import PlusIcon from "@heroicons/react/24/outline/PlusIcon";
import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { setRef } from "../../../../es6";

export enum IMAGE_SIDE {
  FRONT = "FRONT",
  BACK = "BACK",
}

export interface UploadImageProps {
  addFile: (e: React.KeyboardEvent<HTMLDivElement>, fieldId: string) => void;
  upload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  imageSide: IMAGE_SIDE;
}

export const UploadImage = ({ addFile, upload, imageSide }: UploadImageProps) => {
  const isFrontImage = imageSide === IMAGE_SIDE.FRONT;

  const fieldId = isFrontImage ? "addFileFront" : "addFileBack";
  const htmlFor = isFrontImage ? "sid-font-photo-input" : "sid-back-photo-input";
  const ariaLabel = isFrontImage ? "add front file" : "add back file";
  const id = isFrontImage ? "sid-font-photo-input" : "sid-back-photo-input";

  return (
    <div className="sid-step-id-check-loop__file-upload-container">
      <label className="sid-step-id-check-loop__label" htmlFor={htmlFor} aria-label={ariaLabel}>
        <div
          className="sid-step-id-check-loop__upload-photo-container"
          tabIndex={0}
          role="button"
          onKeyDown={(e) => addFile(e, fieldId)}
        >
          <PlusIcon className="sid-step-id-check-loop__icon" />
          <p className="sid-step-id-check-loop__instructions">
            {imageSide === IMAGE_SIDE.FRONT ? (
              <FormattedHTMLMessage
                id="step.idCheckLoop.regula.addFontImage"
                defaultMessage="Add front of ID"
              />
            ) : (
              <FormattedHTMLMessage
                id="step.idCheckLoop.regula.addBackImage"
                defaultMessage="Add back of ID"
              />
            )}
          </p>
          <input
            onChange={upload}
            type="file"
            id={id}
            data-testId="photo-input"
            hidden
            accept="image/jpeg,image/png"
            multiple
            ref={(input: HTMLInputElement) => setRef(fieldId, input)}
          />
        </div>
      </label>
    </div>
  );
};
